// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZD8Oy","icon":"styles_icon__OPR7G","wager":"styles_wager__FL1LW"};